/* eslint-disable max-lines */

export const config = {
    name: 'monthRulesConfigurationSheet',
    selection: true,
    index: false,
    searchFields: [
        {
            name: '标题',
            value: 'title',
            isFixed: true,
            type: 'input',
            span: 4
        }
    ],
    columns: [
        {
            label: '拆解规则单据号',
            prop: 'id',
            width: 160
        },
        {
            label: '标题',
            prop: 'title',
            width: 160
        },
        {
            label: '部门',
            prop: 'deptName',
            width: 140
        },
        {
            label: '分组（岗位）与指标关系表ID',
            prop: 'groupKpiRelationId',
            width: 140
        },
        {
            label: '分组（岗位）',
            prop: 'groupName',
            width: 140
        },
        {
            label: '指标名称',
            prop: 'kpiName',
            width: 140
        },
        {
            label: '拆解规则',
            prop: 'splitRule',
            optionsKey: 'GOAL_MONTHLY_SPLIT_RULE_OPTIONS',
            width: 140
        },
        {
            label: '月度进度表',
            prop: 'monthlyProgressTitle',
            width: 140
        },
        {
            label: '创建人',
            prop: 'createUserName'
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 160
        },
        {
            label: '修改人',
            prop: 'updateUserName'
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            width: 160
        }
    ]
};
